import React, { useState } from 'react';
import {
	Carousel,
	CarouselItem,
	CarouselControl,
	CarouselIndicators,
	CarouselCaption
} from 'reactstrap';

export function CustomCarousel(props) {
	const items = Array.isArray(props.items) ? props.items : [];
	const isEvents = props.isEvents;

	const [activeIndex, setActiveIndex] = useState(0);
	const [animating, setAnimating] = useState(false);

	if (items.length === 0) {
		return null;
	}

	const next = () => {
		if (animating) return;
		const nextIndex =
			activeIndex === items.length - 1 ? 0 : activeIndex + 1;
		setActiveIndex(nextIndex);
	};

	const previous = () => {
		if (animating) return;
		const nextIndex =
			activeIndex === 0 ? items.length - 1 : activeIndex - 1;
		setActiveIndex(nextIndex);
	};

	const goToIndex = (newIndex) => {
		if (animating) return;
		setActiveIndex(newIndex);
	};

	const slides = items.map((item, idx) => (
		<CarouselItem
			key={item?.src || idx}
			onExiting={() => setAnimating(true)}
			onExited={() => setAnimating(false)}
			className={isEvents ? 'events' : ''}
		>
			{!isEvents ? (
				item?.type != null ? (
					<a className="slide-block" href={`/catalog?filter=${item.type}`}>
						<div
							className="slide-image"
							style={{ backgroundImage: `url(${item.src})` }}
						/>
					</a>
				) : (
					<div
						className="slide-image"
						style={{ backgroundImage: `url(${item.src})` }}
					/>
				)
			) : (
				<div className="event-image-container">
					<img
						className="slide-event-image"
						src={item.src}
						alt={item.alt || ''}
					/>
				</div>
			)}

			{item?.caption && (
				<CarouselCaption
					captionHeader={item.caption}
					captionText=""
				/>
			)}
		</CarouselItem>
	));

	return (
		<Carousel
			activeIndex={activeIndex}
			next={next}
			previous={previous}
			enableTouch
		>
			{items.length > 1 && (
				<CarouselIndicators
					items={items}
					activeIndex={activeIndex}
					onClickHandler={goToIndex}
				/>
			)}

			{slides}

			{items.length > 1 && (
				<>
					<CarouselControl
						direction="prev"
						directionText="Previous"
						onClickHandler={previous}
					/>
					<CarouselControl
						direction="next"
						directionText="Next"
						onClickHandler={next}
					/>
				</>
			)}
		</Carousel>
	);
}